import React from 'react';
import { User, Phone, Mail, Briefcase, Star } from 'lucide-react';

const LawyerSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#10B981] to-[#34D399] rounded-xl flex items-center justify-center">
          <User className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">فريق العمل القانوني</h2>
      </div>

      <div className="space-y-6">
        {/* المحامي المسؤول */}
        {caseData.assignedLawyer && (
          <div className="border-2 border-[#C8A870] rounded-xl p-6 bg-gradient-to-br from-amber-50 to-white">
            <div className="flex items-center gap-2 mb-4">
              <Star className="w-5 h-5 text-[#C8A870]" fill="#C8A870" />
              <h3 className="text-lg font-black  style={{ color: primaryColor }}">المحامي المسؤول</h3>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-20 h-20 bg-gradient-to-br from-[#C8A870] to-[#D4B988] rounded-xl flex items-center justify-center flex-shrink-0">
                {caseData.assignedLawyer.photo ? (
                  <img 
                    src={caseData.assignedLawyer.photo} 
                    alt={caseData.assignedLawyer.name}
                    className="w-full h-full object-cover rounded-xl"
                  />
                ) : (
                  <User className="w-10 h-10 text-white" strokeWidth={2.5} />
                )}
              </div>
              
              <div className="flex-1">
                <h4 className="text-2xl font-black text-gray-900 mb-1">{caseData.assignedLawyer.name}</h4>
                <p className="text-[#C8A870] font-bold mb-3">{caseData.assignedLawyer.title}</p>
                
                <div className="space-y-2">
                  {caseData.assignedLawyer.phone && (
                    <div className="flex items-center gap-3 text-gray-700">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                        <Phone className="w-4 h-4 text-blue-600" />
                      </div>
                      <a href={`tel:${caseData.assignedLawyer.phone}`} className="font-bold hover:text-[#C8A870] transition-colors" dir="ltr">
                        {caseData.assignedLawyer.phone}
                      </a>
                    </div>
                  )}
                  {caseData.assignedLawyer.email && (
                    <div className="flex items-center gap-3 text-gray-700">
                      <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                        <Mail className="w-4 h-4 text-emerald-600" />
                      </div>
                      <a href={`mailto:${caseData.assignedLawyer.email}`} className="font-bold hover:text-[#C8A870] transition-colors" dir="ltr">
                        {caseData.assignedLawyer.email}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* المحامي المعاون */}
        {caseData.assistantLawyer && (
          <div className="border-2 border-gray-200 rounded-xl p-6 bg-white hover:border-[#10B981] transition-all">
            <div className="flex items-center gap-2 mb-4">
              <Briefcase className="w-5 h-5 text-[#10B981]" />
              <h3 className="text-lg font-black text-gray-700">المحامي المعاون</h3>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 bg-gradient-to-br from-[#10B981] to-[#34D399] rounded-xl flex items-center justify-center flex-shrink-0">
                <User className="w-8 h-8 text-white" strokeWidth={2.5} />
              </div>
              
              <div className="flex-1">
                <h4 className="text-xl font-black text-gray-900 mb-1">{caseData.assistantLawyer.name}</h4>
                <p className="text-gray-600 font-bold mb-3">{caseData.assistantLawyer.title}</p>
                
                <div className="space-y-2">
                  {caseData.assistantLawyer.phone && (
                    <div className="flex items-center gap-3 text-gray-700">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                        <Phone className="w-4 h-4 text-blue-600" />
                      </div>
                      <a href={`tel:${caseData.assistantLawyer.phone}`} className="font-bold hover:text-[#10B981] transition-colors" dir="ltr">
                        {caseData.assistantLawyer.phone}
                      </a>
                    </div>
                  )}
                  {caseData.assistantLawyer.email && (
                    <div className="flex items-center gap-3 text-gray-700">
                      <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                        <Mail className="w-4 h-4 text-emerald-600" />
                      </div>
                      <a href={`mailto:${caseData.assistantLawyer.email}`} className="font-bold hover:text-[#10B981] transition-colors" dir="ltr">
                        {caseData.assistantLawyer.email}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ملاحظة */}
      <div className="mt-6 bg-blue-50 border-2 border-blue-100 rounded-xl p-4">
        <p className="text-sm text-gray-700 leading-relaxed">
          <span className="font-black  style={{ color: primaryColor }}">ملاحظة:</span> يمكنك التواصل مع فريق العمل القانوني في أي وقت عبر البريد الإلكتروني أو الهاتف. للاستفسارات العاجلة، يرجى إنشاء تذكرة دعم جديدة.
        </p>
      </div>
    </div>
  );
};

export default LawyerSection;